import React, { useContext, useEffect, useState } from "react";
// @ts-expect-error Existing react-chartjs-2 runtime export shape is preserved.
import { Chart } from "react-chartjs-2";
import { Button, Icon } from "@mui/material";
import { LoaderContext } from "@/helpers/contexts/contexts";
import pdfDownloadHelper from "@/features/campaigns/shared/helpers/pdfDownloadHelper";

Chart.defaults.global.animation.duration = 0;

type PDFDownloadButtonProps = {
  elId: string;
  label: React.ReactNode;
  fileName?: string;
};

const PDFDownloadButton = ({
  elId,
  label,
  fileName = "report",
}: PDFDownloadButtonProps) => {
  const loader = useContext(LoaderContext);
  const [processing, setProcessing] = useState<boolean | number>(false);

  useEffect(() => {
    loader(processing as boolean);
  }, [processing, loader]);

  return (
    <Button
      onClick={() => {
        setProcessing(() => 1);
        setTimeout(() => {
          pdfDownloadHelper(
            processing,
            setProcessing as unknown as () => void,
            elId,
            fileName
          );
        }, 1000);
      }}
      startIcon={<Icon>file_download</Icon>}
      variant="outlined"
      className="text-capitalize"
      disableRipple
      fullWidth
      disableElevation
    >
      {label}
    </Button>
  );
};

export default PDFDownloadButton;
